import { ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

import { PlanningSegment, PlanningSegmentType, UntilDestroy } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: '[cng-agent-planning-slot]',
  templateUrl: 'agent-planning-slot.component.html',
  styleUrls: ['./agent-planning-slot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentPlanningSlotComponent implements OnDestroy {
  @Input()
  set slot(value: PlanningSegment) {
    if (!!value) {
      this._slot$.next(value);
    }
  }
  get slot$() {
    return this._slot$.pipe(distinctUntilChanged());
  }
  private readonly _slot$ = new BehaviorSubject<PlanningSegment | undefined>(undefined);

  /**
   * Class open
   */
  @HostBinding('class.open')
  get shouldClassOpen() {
    const slot = this._slot$.value;
    return !!slot && slot.type === PlanningSegmentType.opened;
  }

  /**
   * Class partially open
   */
  @HostBinding('class.partially_open')
  get shouldClassPartiallyOpen() {
    const slot = this._slot$.value;
    return !!slot && slot.type === PlanningSegmentType.partial;
  }

  ngOnDestroy() {
    this._slot$.complete();
  }
}
